const countries = [{
    name: 'Netherlands',
    abbr: 'NL',
    id: 1
  },
  {
    name: 'Germany',
    abbr: 'GE',
    id: 2
  },
  {
    name: 'France',
    abbr: 'FR',
    id: 3
  },
  {
    name: 'United Kingdom',
    abbr: 'UK',
    id: 4
  },
  {
    name: 'Spain',
    abbr: 'SP',
    id: 5
  },
  {
    name: 'India',
    abbr: 'IN',
    id: 6
  },
  {
    name: 'Italy',
    abbr: 'IT',
    id: 7
  },
  {
    name: 'Belgium',
    abbr: 'BE',
    id: 8
  },
  {
    name: 'Portugal',
    abbr: 'PO',
    id: 9
  },
  {
    name: 'Romania',
    abbr: 'RO',
    id: 28
  },
  {
    name: 'Croatia',
    abbr: 'CR',
    id: 10
  },
  {
    name: 'Czech Republic',
    abbr: 'CZ',
    id: 11
  },
  {
    name: 'Denmark',
    abbr: 'D',
    id: 12
  },
  {
    name: 'Sweden',
    abbr: 'S',
    id: 13
  },
  {
    name: 'Ireland',
    abbr: 'I',
    id: 14
  },
  {
    name: 'Poland',
    abbr: 'P',
    id: 29
  },
  {
    name: 'Bulgaria',
    abbr: 'B',
    id: 15
  },
  {
    name: 'Hungary',
    abbr: 'H',
    id: 16
  },
  {
    name: 'Slovakia',
    abbr: 'Sl',
    id: 17
  },
  {
    name: 'Luxembourg',
    abbr: 'L',
    id: 18
  },
  {
    name: 'Finland',
    abbr: 'F',
    id: 19
  },
  {
    name: 'Cyprus',
    abbr: 'Cy',
    id: 20
  },
  {
    name: 'Estonia',
    abbr: 'Es',
    id: 21
  },
  {
    name: 'Greece',
    abbr: 'Gr',
    id: 22
  },
  {
    name: 'Latvia',
    abbr: 'La',
    id: 23
  },
  {
    name: 'Malta',
    abbr: 'La',
    id: 24
  },
  {
    name: 'Lithuania',
    abbr: 'Li',
    id: 25
  },
  {
    name: 'Slovenia',
    abbr: 'Slo',
    id: 26
  },
  {
    name: 'Austria',
    abbr: 'Au',
    id: 26
  }
];

export {countries};